module.exports = __webpack_public_path__ + "static/img/storageBottom3.8e5bebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageBottom3.png
// module id = TMra
// module chunks = 2